// Public exports for the banners module

export { BannerBar } from './components/BannerBar/BannerBar';
export { AdminBannersPage } from './components/AdminBannersPage/AdminBannersPage';
export * from './types';

// Admin hub registration card for this module
import type { AdminCard } from '../../admin/types';

export const bannerAdminCard: AdminCard = {
  title: 'General',
  description:
    'General portal configuration and site-wide settings.',
  subCards: [
    {
      title: 'Banners',
      description:
        'Create and manage announcement banners shown at the top of every page.',
      to: '/oneadvanced-admin/banners',
    },
  ],
};
